import HeaderEvents from "./HeaderEvents";

export const changeMenu = (from: string, to: string, direction: string) => ({
    type: HeaderEvents.ChangeMenu,
    from, to, direction
} as const);

// 使っていないので、一旦コメントアウトする
// export const onScroll = (scrollTop: number) => ({
//     type: HeaderEvents.OnScroll,
//     scrollTop
// } as const);
